import './App.css';
import { useEffect } from 'react';

// Components
import About from './components/About/About';
import Tech from './components/Tech/Tech';
import Projects from './components/Projects/Projects';
import Experience from './components/Experience/Experience';
import Layout from './components/Layout';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';

// Routes
import Winnable from './components/Projects/Winnable/Winnable';
import InsightTube from './components/Projects/InsightTube/InsightTube';
import IcyVillage from './components/Projects/IcyVillage/IcyVillage';
import FreshPotatoes from './components/Projects/FreshPotatoes/FreshPotatoes';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }, [pathname]);

  return null;
};

function App() {
  function Home() {
    return (
      <>
        <About />
        <p className="section-title">Experience</p>
        <Experience />
        <p className="section-title">Tech</p>
        <Tech />
        <p className="section-title">Projects</p>
        <Projects />
      </>
    );
  }

  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" index element={<Home />} />
          <Route path="project/winnable" element={<Winnable />} />
          <Route path="project/insighttube" element={<InsightTube />} />
          <Route path="project/icyvillage" element={<IcyVillage />} />
          <Route path="project/freshpotatoes" element={<FreshPotatoes />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
